import React from "react";
import { LegalLayout, CompanyInfoTable } from "./LegalLayout";
import { COMPANY } from "@/lib/company";

export default function MesafeliSatis() {
  return (
    <LegalLayout title="Mesafeli Satış Sözleşmesi">
      <h2>1. Taraflar ve Konu</h2>
      <p>
        İşbu Mesafeli Satış Sözleşmesi ("Sözleşme"), aşağıda bilgileri yer alan SATICI ile {COMPANY.brand}
        ({COMPANY.websiteLabel}) üzerinden dijital abonelik hizmeti satın alan ALICI arasında,
        6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümlerine
        uygun olarak elektronik ortamda kurulmuştur. ALICI, hizmeti satın alarak işbu Sözleşme'nin tüm
        şartlarını okuduğunu ve kabul ettiğini beyan eder.
      </p>

      <h2>2. Satıcı Bilgileri</h2>
      <CompanyInfoTable />

      <h2>3. Sözleşme Konusu Hizmet</h2>
      <p>
        Sözleşme'nin konusu, {COMPANY.brand} platformu aracılığıyla sunulan online rezervasyon yönetimi
        yazılımına (SaaS) ilişkin dijital abonelik hizmetidir. Hizmetin niteliği, kapsamı, süresi (aylık/yıllık)
        ve güncel satış bedeli (KDV dahil), satın alma öncesinde <a href={COMPANY.website}>{COMPANY.websiteLabel}</a>{" "}
        üzerindeki "Abonelik / Planlar" sayfasında ALICI'ya açıkça gösterilir. ALICI, ödeme adımından önce
        seçtiği planı, süresini ve toplam bedeli görüntüler ve onaylar.
      </p>

      <h2>4. Bedel ve Ödeme</h2>
      <ul>
        <li>Hizmet bedeli, ALICI'nın seçtiği plana göre belirlenir ve ödeme sayfasında KDV dahil olarak gösterilir.</li>
        <li>Ödemeler, PayTR altyapısı üzerinden güvenli ödeme yöntemleri (kredi/banka kartı) ile tahsil edilir. Kart bilgileri {COMPANY.brand} tarafından saklanmaz.</li>
        <li>Abonelik, ALICI otomatik yenilemeyi kapatmadığı sürece seçilen dönem sonunda aynı bedelle yenilenir.</li>
      </ul>

      <h2>5. Hizmetin İfası ve Teslim</h2>
      <p>
        Hizmet dijital olup, ödeme onaylandığı anda ALICI'nın hesabında <strong>anında aktifleştirilir</strong>.
        Fiziksel teslimat ve kargo söz konusu değildir. ALICI, kayıt olduğu e-posta ve şifre ile hizmete
        derhal erişebilir.
      </p>

      <h2>6. Cayma Hakkı</h2>
      <p>
        Mesafeli Sözleşmeler Yönetmeliği'nin 15/1-(ğ) maddesi gereğince, elektronik ortamda anında ifa
        edilen ve tüketiciye anında teslim edilen gayrimaddi (dijital) hizmetlerde <strong>cayma hakkı
        bulunmamaktadır</strong>. ALICI, satın alma işlemiyle birlikte hizmetin anında ifasına onay verdiğini
        ve bu kapsamda cayma hakkının olmadığını kabul eder.
      </p>

      <h2>7. İptal ve İade</h2>
      <p>
        ALICI aboneliğini dilediği an panelinden iptal edebilir; iptal hâlinde ödenmiş dönem sonuna kadar
        hizmet devam eder ve sonraki dönem için tahsilat yapılmaz. İade koşulları,{" "}
        <a href="/iptal-iade-kosullari">İptal ve İade Koşulları</a> sayfasında ayrıntılı olarak düzenlenmiştir.
      </p>

      <h2>8. Gizlilik ve Kişisel Veriler</h2>
      <p>
        ALICI'ya ait kişisel veriler, <a href="/gizlilik-kvkk">Gizlilik ve KVKK Politikası</a> kapsamında
        işlenir ve korunur.
      </p>

      <h2>9. Uyuşmazlıkların Çözümü</h2>
      <p>
        İşbu Sözleşme'den doğabilecek uyuşmazlıklarda, Ticaret Bakanlığı'nca ilan edilen parasal sınırlar
        dâhilinde ALICI'nın yerleşim yerindeki Tüketici Hakem Heyetleri ile Tüketici Mahkemeleri yetkilidir.
      </p>

      <h2>10. Yürürlük</h2>
      <p>
        ALICI, elektronik ortamda ödeme işlemini onayladığında işbu Sözleşme'nin tüm maddelerini kabul
        etmiş ve Sözleşme yürürlüğe girmiş sayılır.
      </p>
    </LegalLayout>
  );
}
